import Model from './model.js'

export default {
  PingToServer(params) {
    Model.PingToServer(params)
  }
}


// WEBPACK FOOTER //
// ./src/App/system/ping/presenter.js